import React from 'react'

const SalesSection: React.FC = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <img src="/images/home/banner/1515.jpg" alt="VizslaChat Banner" style={{ maxWidth: '100%', height: 'auto', borderRadius: '15px' }} />
    </div>
  )
}

export default SalesSection
